import { Button, Row } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { ReactNode, useCallback, useMemo, useState } from "react";
import { useStatusTag } from "../../Accounts/hooks/statusTag";
import { SearchInput } from "../../../components/SearchInput";
import { useSearchByNumber } from "../../../lib/hooks/searchByNumber";
import { searchByNumber } from "../../../acions/accounts/contracts";
import { NavigateFunction, useNavigate } from "react-router-dom";
import ROUTES from "../../../configs/routesConfig";

type AccountHeaderProps = {
  accountNumber: string;
  xRef?: string;
  accountStatus: string | number;
  enableSearch: boolean;
  onBackButtonClicked: () => void;
  reduceBackStep?: () => void;
};

export const AccountHeader = ({
  accountNumber,
  xRef,
  accountStatus,
  enableSearch,
  onBackButtonClicked,
  reduceBackStep,
}: AccountHeaderProps) => {
  const navigate: NavigateFunction = useNavigate();

  const [isSearch, setIsSearch] = useState<boolean>(false);

  const toggleIsSearch = useCallback(() => setIsSearch(!isSearch), [isSearch]);

  const onSearchSuccess = useCallback(
    (value: any): void => {
      if (value && value.id) {
        navigate(`${ROUTES.ACCOUNTS}/${value.id}`);
        reduceBackStep && reduceBackStep();
        toggleIsSearch();
      }
    },
    [navigate, toggleIsSearch, reduceBackStep],
  );

  const title: string = useMemo(
    () => `Account: ${accountNumber}`,
    [accountNumber],
  );

  const { search, isLoading } = useSearchByNumber(
    onSearchSuccess,
    searchByNumber,
  );

  const { getStatus } = useStatusTag();

  const status: string | ReactNode = useMemo(
    () => getStatus(accountStatus),
    [getStatus, accountStatus],
  );

  return (
    <Row className="align-center">
      <Button
        shape="circle"
        icon={<ArrowLeftOutlined />}
        size="large"
        className="back-btn mr-6"
        onClick={onBackButtonClicked}
      />
      {enableSearch ? (
        <SearchInput
          title={title}
          isLoading={isLoading}
          isSearch={isSearch}
          search={search}
          setIsSearch={setIsSearch}
          toggleIsSearch={toggleIsSearch}
          initialValue={accountNumber}
        />
      ) : (
        <h3 className="h h3 mr-8">
          <span className="desktop-label">Account:</span> {accountNumber}
        </h3>
      )}
      {!isSearch && (
        <>
          {status}
          {xRef && <div className="ml-2 text-md w-400">X-Ref: {xRef}</div>}
        </>
      )}
    </Row>
  );
};
